import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { noop } from 'ui-components/default-props/noop';
import { Tooltip } from 'ui-components/components/tooltip';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import style from './inputs.module.less';

const DefaultOption = ({ label, checked = false, onCheck = noop, tooltip = null }) => {
  return (
    <div className={style['default-option']}>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {tooltip && (
        <Tooltip text={<FormattedMessage {...tooltip} />}>
          <div className={style['information-icon']}>
            <FontAwesomeIcon icon={faQuestionCircle} />
          </div>
        </Tooltip>
      )}
    </div>
  );
};

DefaultOption.propTypes = {
  label: FormattedMessagePropType.isRequired,
  tooltip: FormattedMessagePropType,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
};

export default DefaultOption;
